<template>
    <div>
        <v-form
            ref="form"
            v-model="formValid"
        >
            <div>
                <v-row class="px-8">
                    <v-col cols="12" class="col-md-5">
                        <div class="d-flex align-center justify-center pt-6">
                            <multiple-image-input @value-change="imagesValue"></multiple-image-input>
                        </div>
                        <div class="d-flex pt-0 align-center justify-center">
                            <div v-for="image in formData.initialImages" :key="image.id" style="position: relative">
                                <v-img :src="image.url" width="80px" class="mx-2 initial-image elevation-2"></v-img>
                                <v-icon color="grey" class="remove-icon" size="24" @click="showDeleteSnack(image.id)">close</v-icon>
                            </div>
                        </div>
                    </v-col>
                    <v-col class="col-md-7">
                        <v-row class="py-1">
                            <v-col cols="12" class="col-sm-8 pb-0 pb-sm-4">
                                <v-autocomplete
                                    v-model="formData.seller"
                                    :items="sellersData"
                                    :loading="isSellersLoading"
                                    hide-no-data
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    :label="$t('seller')"
                                    cache-items
                                    flat
                                    class="width-300 pa-0 ma-0"
                                    color="teal lighten-2"
                                    item-color="teal lighten-2"
                                    :rules="rules"
                                    required
                                    clearable
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" class="col-sm-4 pt-0 mb-4">
                                <v-checkbox
                                    class="mt-0 mt-md-2"
                                    v-model="formData.selfShipment"
                                    :label="$t('shipmentAgrolink')"
                                    hide-details
                                    color="teal lighten-2"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <div class="py-1">
                            <v-autocomplete
                                v-model="formData.mainCategory"
                                :items="mainCategoryData"
                                :loading="isMainCategoryLoading"
                                hide-no-data
                                item-text="name"
                                item-value="id"
                                return-object
                                :label="$t('section')"
                                cache-items
                                flat
                                class="width-300 pa-0 ma-0"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                                :rules="rules"
                                required
                                clearable
                            ></v-autocomplete>
                        </div>
                        <div class="py-1">
                            <v-autocomplete
                                v-model="formData.category"
                                :items="categoriesData"
                                :loading="isSubCategoryLoading"
                                :disabled="isSubCategoryLoading"
                                hide-no-data
                                item-text="name"
                                item-value="id"
                                return-object
                                :label="$t('category')"
                                flat
                                class="width-300 pa-0 ma-0"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                                :rules="rules"
                                required
                                clearable
                            ></v-autocomplete>
                        </div>
                        <div class="py-1">
                            <v-autocomplete
                                v-model="formData.manufacturer"
                                :items="manufacturersData"
                                :loading="isManufacturersLoading"
                                :disabled="isManufacturersLoading"
                                hide-no-data
                                item-text="name"
                                item-value="id"
                                return-object
                                :label="$t('producer')"
                                flat
                                class="width-300 pa-0 ma-0"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                                :rules="rules"
                                required
                                clearable
                            ></v-autocomplete>
                        </div>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-title class="pt-3 pb-4 px-9 subtitle-2">{{$t('mainInfo')}}</v-card-title>
                <v-row class="px-8">
                    <v-col cols="12" class="col-md-5 pb-0 pb-md-4">
                        <div>
                            <v-text-field
                                class="pt-0"
                                :label="$t('nameRu')"
                                v-model="formData.productNameRu"
                                color="teal lighten-2"
                                :rules="rules"
                                required
                            ></v-text-field>
                        </div>
                        <div>
                            <v-text-field
                                class="pt-0"
                                :label="$t('nameUa')"
                                v-model="formData.productNameUa"
                                color="teal lighten-2"
                                :rules="rules"
                                required
                            ></v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12" class="col-md-5 py-0 pt-md-4">
                        <div>
                            <v-text-field
                                class="pt-0"
                                :label="$t('articleNumber')"
                                v-model="formData.articleNumber"
                                color="teal lighten-2"
                            ></v-text-field>
                        </div>
                        <div>
                            <v-autocomplete
                                v-model="formData.packingType"
                                :items="packingTypeData"
                                hide-no-data
                                item-text="name"
                                item-value="id"
                                return-object
                                :label="$t('packing')"
                                flat
                                class="pt-0"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                                :rules="rules"
                                required
                                clearable
                            ></v-autocomplete>
                        </div>
                    </v-col>
                    <v-col cols="12" class="col-md-2 py-0 pt-md-4">
                        <v-row>
                            <v-col cols="6" class="col-md-12 pb-md-0">
                                <div>
                                    <v-text-field
                                        v-model="formData.packingQuantity"
                                        :label="$t('quantity')"
                                        :rules="rules"
                                        required
                                        class="pt-0"
                                        color="teal lighten-2"
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="6" class="col-md-12 pt-3 pt-md-0">
                                <div>
                                    <v-autocomplete
                                        v-model="formData.quantityUnits"
                                        :label="$t('unitOfMeasure')"
                                        :items="quantityUnitsData"
                                        hide-no-data
                                        item-text="name"
                                        item-value="id"
                                        return-object
                                        flat
                                        class="pt-0"
                                        color="teal lighten-2"
                                        item-color="teal lighten-2"
                                        :rules="rules"
                                        required
                                        clearable
                                    ></v-autocomplete>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row class="px-8 pt-4">
                    <v-col cols="12" class="col-md-3">
                        <v-card-title class="pt-0 subtitle-2">
                            {{ $t('minOrder') }}&nbsp;
                            <v-tooltip
                                top
                                fixed
                                max-width="500"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        color="grey"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                    >info</v-icon>
                                </template>
                                <span>{{$t('minimumOrderHelp')}}</span>
                            </v-tooltip>
                        </v-card-title>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="formData.minValueQuantity"
                                    :label="$t('quantity')"
                                    color="teal lighten-2"
                                    dense
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="formData.packingType"
                                    :items="packingTypeData"
                                    :disabled="isPackByDisabled"
                                    dense
                                    outlined
                                    hide-no-data
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    :label="$t('packedBy')"
                                    flat
                                    class="width-300 ma-0"
                                    color="teal lighten-2"
                                    item-color="teal lighten-2"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="col-md-6">
                        <v-card-title class="pt-0 subtitle-2">
                            {{ $t('price') }} {{ $t('for') }} {{ selectedUnits ? '1 ' + selectedUnits : '' }}
                        </v-card-title>
                        <v-row>
                            <v-col cols="12">
                                <v-row>
                                    <v-col cols="12" class="col-md-6">
                                        <v-text-field
                                            v-model="formData.price"
                                            :label="formData.currency.name"
                                            color="teal lighten-2"
                                            dense
                                            outlined
                                            :rules="rules"
                                            requred
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="col-md-6">
                                        <v-text-field
                                            disabled
                                            outlined
                                            dense
                                            :value="totalPrice"
                                            :label="`${ $t('price') } ${ $t('for') } ${ minimumPackingType || '' }`"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="6">
                                <v-select
                                    v-model="formData.currency"
                                    :items="currencies"
                                    hide-no-data
                                    dense
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    :label="$t('currency')"
                                    flat
                                    color="teal lighten-2"
                                    item-color="teal lighten-2"
                                    :rules="rules"
                                    required
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox
                                    class="mt-0"
                                    v-model="formData.withNds"
                                    :label="$t('withNds')"
                                    color="teal lighten-2"
                                    @change="changeNds"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="col-md-3">
                        <v-card-title class="pt-0 subtitle-2">{{ $t('priceWithDiscount') }}</v-card-title>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="discountPrice"
                                    :label="formData.currency.name"
                                    color="teal lighten-2"
                                    dense
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="formData.discountPercent"
                                    disabled
                                    :label="$t('discountInPercent')"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-card-title class="pt-0 px-9 subtitle-2">{{$t('dimensions')}}</v-card-title>
                <v-row class="px-8">
                    <v-col cols="12" class="col-sm-6 col-md-3">
                        <v-text-field
                            v-model="formData.packLength"
                            :label="`${$t('length')}, ${$t('m')}`"
                            color="teal lighten-2"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="col-sm-6 col-md-3">
                        <v-text-field
                            v-model="formData.packWidth"
                            :label="`${$t('width')}, ${$t('m')}`"
                            color="teal lighten-2"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="col-sm-6 col-md-3">
                        <v-text-field
                            v-model="formData.packHeight"
                            :label="`${$t('height')},  ${$t('m')}`"
                            color="teal lighten-2"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="col-sm-6 col-md-3">
                        <v-text-field
                            v-model="formData.packWeight"
                            :label="`${$t('weight')}, ${$t('kg')}`"
                            color="teal lighten-2"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-title class="pt-4 pb-0 px-9 subtitle-2">{{$t('characteristics')}}</v-card-title>
                <v-row class="px-8" >
                    <v-col cols="12">
                        <product-attributes
                            :product-attributes="productAttributes"
                            :initial-attributes="initialAttributes"
                            @attribute-change="changeAttributes"
                        ></product-attributes>
                    </v-col>
                </v-row>
                <v-row class="px-8 pb-3">
                    <v-col cols="12">
                        <v-card-title class="pt-0 px-9 subtitle-2">{{$t('descriptionRu')}}</v-card-title>
                        <ckeditor
                            :editor="editor"
                            @change="test"
                            v-model="formData.descriptionRu"
                            :config="editorConfig"
                            class="border-transparent"
                            :rules="rules"
                            required
                        ></ckeditor>
                    </v-col>
                    <v-col cols="12">
                        <v-card-title class="pt-0 px-9 subtitle-2">{{$t('descriptionUa')}}</v-card-title>
                        <ckeditor
                            :editor="editor"
                            v-model="formData.descriptionUa"
                            :config="editorConfig"
                            class="border-transparent"
                            :rules="rules"
                            required
                        ></ckeditor>
                    </v-col>
                </v-row>
                <div class="d-flex justify-content-center pa-8">
                    <v-btn
                        depressed
                        class="white--text teal"
                        :disabled="!formValid"
                        @click="validate"
                    >{{$t('save')}}</v-btn>
                </div>
            </div>
        </v-form>
        <v-snackbar :color="snackColor" v-model="snackOpen">
            {{ $t('remove') }} ?
            <div>
                <v-btn text class="text--main-yellow" @click="removeImage">{{ $t('yes') }}</v-btn>
                <v-btn text icon @click="snackOpen = false">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </div>
</template>

<script>

import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import MyUploadAdapter from "../../plugins/ckeditor-upload-adapter/MyUploadAdapter"
import '@ckeditor/ckeditor5-build-classic/build/translations/ru'

import MultipleImageInput from '../../general/image/multiple-image-input';
import ProductAttributes from "../products/ProductAttributes";
import { MixinAppSnack, MixinProductUpdateInitial } from "../../mixins";
import {InfoService, authService} from "../../services";
import { normalizeFloat } from '../../utils';

export default {
    name: "ProductForm",
    mixins: [ MixinAppSnack, MixinProductUpdateInitial ],
    components: {
        ProductAttributes,
        MultipleImageInput
    },
    props: [ 'page' ],
    data() {
        return {
            formValid: false,
            rules: [value => !!value || this.$t('requiredField')],
            editor: ClassicEditor,
            editorConfig: {
                extraPlugins: [this.uploadAdapter],
                language: 'ru',
                label: this.$t('description'),
            },
            productAttributes: [],
            formData: {
                seller: null,
                selfShipment: false,
                articleNumber: null,
                category: null,
                productImages: [],
                mainCategory: null,
                manufacturer: null,
                initialImages: [],
                productNameRu: null,
                productNameUa: null,
                packingType: null,
                packingQuantity: null,
                quantityUnits: null,
                minValueQuantity: null,
                packLength: null,
                packWidth: null,
                packHeight: null,
                packWeight: null,
                price: null,
                currency: this.$store.getters.currencies[0],
                withNds: null,
                discountPercent: 0,
                descriptionRu: '',
                descriptionUa: '',
                attributes: {},
            },
            sellersData: [],
            mainCategoryData: [],
            categoriesData: [],
            manufacturersData: [],
            packingTypeData: [],
            quantityUnitsData: [],
            discountPrice: null,
            characteristics: [],
            isSellersLoading: false,
            isMainCategoryLoading: false,
            isSubCategoryLoading: false,
            isManufacturersLoading: false,
        }
    },
    computed: {
        currencies() {
            return this.$store.getters.currencies;
        },
        isPackByDisabled() {
            return !!this.formData.packingType;
        },
        minimumPackingType() {
            return this.formData.packingType ? this.formData.packingType.name : null;
        },
        selectedUnits() {
            return this.formData.quantityUnits ? this.formData.quantityUnits.name : null;
        },
        totalPrice() {
            const { packingQuantity, price } = this.formData;
            const normalizedPrice = normalizeFloat(price);

            return !Number.isNaN(+packingQuantity) && !Number.isNaN(+normalizedPrice)
                ? +packingQuantity * +normalizedPrice
                : 0;
        },
    },
    methods: {
        test(data) {
            console.log(data);
        },
        changeAttributes(data) {
            this.formData.attributes = {
                enumAttributes: this.getEnumAttributes(data),
                numericAttributes: this.getNumericAttributes(data),
                subEnumAttributes: data.subEnumAttributes,
            };
        },
        getBaseInfo(mainCategoryID) {
            this.isSubCategoryLoading = true;
            this.isManufacturersLoading = true;
            InfoService.setAuth(this.$store.getters.token);
            InfoService.getSubCategories(mainCategoryID)
                .then(res => {
                    this.categoriesData = res.data;
                })
                .catch(console.log)
                .finally(() => {
                    this.isSubCategoryLoading = false;
                });

            InfoService.getCategoryManufacturers(mainCategoryID)
                .then(res => {
                    this.manufacturersData = res.data;
                })
                .catch(console.log)
                .finally(() => {
                    this.isManufacturersLoading = false;
                });

            InfoService.getCategoryPacks(mainCategoryID)
                .then(res => {
                    this.packingTypeData = res.data;
                })
                .catch(console.log);

            InfoService.getQuantityUnits()
                .then(res => {
                    this.quantityUnitsData = res.data;
                })
                .catch(console.log);
        },
        getAttributesCategory(categoryID) {
            InfoService.setAuth(this.$store.getters.token);
            InfoService.getAttributesCategory(categoryID)
                .then(res => {
                    this.productAttributes = res.data;
                })
                .catch(console.log)
        },
        changeNds(data) {
            this.formData.withNds = data;
        },
        imagesValue(data) {
            this.formData.productImages = data;
        },
        getEnumAttributes(data) {
            if(!data.enumAttributes)
                return [];

            const values = Object.values(data.enumAttributes);
            const result = [];
            values.forEach(value => {
                if (!value) {
                    return;
                }
                if (Array.isArray(value)) {
                    value.forEach(item => {
                        result.push(item);
                    })
                } else {
                    result.push(value);
                }
            });

            return result;
        },
        getNumericAttributes(data) {
            if(!data.numericAttributes && !data.numericEnum)
                return [];
            const resultSimple = data.numericAttributes || [];
            const resultEnum = [];
            const valuesEnum = Object.values(data.numericEnum)

            valuesEnum.forEach(item => {
                item.forEach(itemValue => {
                    const {attributeID, unitID, valueID, value, minValue, maxValue} = itemValue;
                    resultEnum.push({
                        attributeID,
                        unitID,
                        valueID,
                        value,
                        minValue,
                        maxValue,
                    });
                })
            });

            return [...resultSimple, ...resultEnum];
        },
        removeImage() {
            this.$emit('remove-image', this.imageRemoved);
            this.snackOpen = false;
            this.imageRemoved = null;
        },
        setMainCategories() {
            this.isMainCategoryLoading = true;
            InfoService.setAuth(this.$store.getters.token);
            InfoService.getMainCategories()
                .then(res => {
                    this.mainCategoryData = res.data;
                })
                .catch(console.log)
                .finally(() => {
                    this.isMainCategoryLoading = false;
                })
        },
        setSellers() {
            this.isSellersLoading = true;
            InfoService.setAuth(this.$store.getters.token);
            InfoService.getSellers()
                .then(res => {
                    this.sellersData = res.data;
                })
                .catch(console.log)
                .finally(() => {
                    this.isSellersLoading = false;
                })
        },
        showDeleteSnack(id) {
            this.imageRemoved = id;
            this.resetSnack();
            this.setDeleteSnack();
            this.openSnack();
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit('validated', this.formData);
            }
        },
        uploadAdapter(editor)
        {
            const options = {
                uploadUrl: '/api/upload-description-images',
                headers: {...authService.getAuthHeader()}
            };

            editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                return new MyUploadAdapter( loader, options );
            };
        },
    },
    created() {
        this.setMainCategories();
        this.setSellers();
    },
    watch: {
        discountPrice(value) {
            const price = parseFloat(this.formData.price);
            const discountPrice = parseFloat(value);
            this.formData.discountPercent = (!isNaN(price) && !isNaN(discountPrice)) ? ((1 - discountPrice / price) * 100).toFixed(2) : 0;
        },
        'formData.mainCategory'(value, old) {
            if(old && !_.isPlainObject(this.initial))
                this.formData.category = null;

            if (value) {
                this.getBaseInfo(value.id);
            }
        },
        'formData.category'(value) {
            if (value && value.id) {
                this.getAttributesCategory(value.id);
            }
        },
    }
}
</script>

<style lang="scss">
    .ck-editor__editable {
        min-height: 200px;
    }
</style>
